/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2024-04-22 16:49:57
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-22 19:27:34
 * @FilePath: \xyjh-web\src\utils\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Cookies from "js-cookie";

const TokenKey = "UserToken";
const twoHours = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: twoHours,
  });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getUserInfo() {
  return Cookies.get("UserInfo");
}

export function setUserInfo(token) {
  return Cookies.set("UserInfo", token);
}
export function removeUserInfo() {
  return Cookies.remove("UserInfo");
}
export function setUserPropagateInfo(token) {
  return Cookies.set("UserPropagateInfo",token);
}

export function getUserPropagateInfo() {
  return Cookies.get("UserPropagateInfo");
}

export function removeUserPropagateInfo() {
  return Cookies.remove("UserPropagateInfo");
}